module.exports = __webpack_public_path__ + "img/password-light.78eb0efa.svg";